import React from 'react';
import AppLayout from '../../layout/app.layout';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import EngagementReports from '../../components/reports/engagement-reports.component';

const EngagementReportsView = () => {
  const pageTitle = PAGE_TITLE_LIST.REPORTS_ENGAGEMENT;

  return (
    <AppLayout pageTitle={pageTitle}>
      <EngagementReports />
    </AppLayout>
  );
};

export default EngagementReportsView;
